//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PagamentosSolicitadosTabela from './PagamentosSolicitadosTabelaDash';
import PagamentosAprovacoesTabela from './PagamentosAprovacoesTabelaDash';
import pagamentoMixin from './pagamento';
import BoxValoresPagamentos from './pagamento/BoxValoresPagamentos';
import ValoresPagamentos from './pagamento/ValoresPagamentos';
import { skipLoading } from '../../../../../common/functions/loading';

export default {
  name: 'DashboardPagamento',
  mixins: [pagamentoMixin],
  data() {
    return {
      filtros: {},
      carregado: false,
      carregandoBox: false,
      carregandoTable: false,
      bloquearConsulta: false,
      paginas: 0,
    };
  },
  components: {
    PagamentosSolicitadosTabela,
    PagamentosAprovacoesTabela,
    BoxValoresPagamentos,
  },
  methods: {
    organizar(ordenacao, source = null) {
      sortTableColumn(source || this.negociacoes, ordenacao);
    },
    refreshData() {
      this.$refs.pagamentoTabela.refazPaginacao();
      if (this.periodo) {
        this.filtros.periodo = String(this.periodo).replace('/', '').replace(/^(\d{2})(\d{4})/, '$2$1');
      } else {
        delete this.filtros.periodo;
      }
      if (this.idUnidadeNegocio) {
        this.filtros.idUnidadeNegocio = this.idUnidadeNegocio;
      } else {
        delete this.filtros.idUnidadeNegocio;
      }

      this.requestCarregarConsolidadoPagamento();
      this.requestCarregarPagamentosAprovacoes();
    },
    requestCarregarConsolidadoPagamento() {
      skipLoading();
      this.carregandoBox = true;
      this.dashboardPagamentoResources.listarDash(this.filtros)
        .then((response) => {
          this.carregandoBox = false;
          this.valoresPagamentos = new ValoresPagamentos(response.data);
        })
        .catch((err) => {
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoBox = false;
        });
      return this;
    },
    requestCargaPeriodos() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.dashboardPagamentoResources.listarPeriodos()
          .then((response) => {
            this.periodos = response.data;
            resolve();
          }).catch(reject);
      });
    },
    requestGetUnidadesNegocio() {
      return new Promise((resolve, reject) => {
        skipLoading();
        this.usuarioUnidadeNegocioResources.listarAtivos()
          .then((response) => {
            this.unidadesNegocio = response.data;
            resolve();
          }).catch(reject);
      });
    },
    filtrarFluxos(filtro) {
      this.$refs.pagamentoTabela.refazPaginacao();
      this.requestCarregarPagamentosAprovacoes(filtro);
    },
    requestCarregarPagamentosAprovacoes(filtros = {}, pagina = 0, cb) {
      this.bloquearConsulta = true;
      const merged = Object.assign(this.filtros, filtros);

      skipLoading();
      this.carregandoTable = true;

      merged.tamanhoPagina = 20;
      merged.numeroPagina = pagina;

      this.dashboardPagamentoResources.listarPagamentosAprovacoes(merged)
        .then((response) => {
          this.bloquearConsulta = false;
          this.pagamentosAprovacoes = response.data.resposta;
          const qtdeRegistros = response.data.quantidadeRegistrosPagina;
          this.paginas = Math.ceil(qtdeRegistros / merged.tamanhoPagina);
          this.carregandoTable = false;
          if (cb) {
            cb();
          }
        })
        .catch((err) => {
          this.bloquearConsulta = false;
          this.$toast.create(this.$t(err), 'snack', 3E3);
          this.carregandoTable = false;
        });
    },
    abreCarrega() {
      if (this.carregado) {
        return;
      }

      window.setTimeout(() => {
        this.requestCargaPeriodos()
          .then(this.requestGetUnidadesNegocio)
          .then(() => {
            this.carregado = true;
            this.requestCarregarConsolidadoPagamento();
            this.requestCarregarPagamentosAprovacoes();
          })
          .catch((err) => {
            this.$toast.create(this.$t(err), 'snack', 3E3);
          });
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/DashboardPagamento.vue?vue&type=script&lang=js&